import React from 'react';
import { compose } from 'redux';
import { Link } from 'react-router-dom';

import userPage from '../../decorators/userPage';
import withPurchaseMethods from '../../decorators/withPurchaseMethods';
import UserPaymentMethodDetails from '../../components/UserPaymentMethodDetails/UserPaymentMethodDetails';
import UserECheckPaymentMethodDetails from '../../components/UserPaymentMethodDetails/UserECheckPaymentMethodDetails';
import Pagination from '../../components/Pagination/Pagination';

const getPaymentIdFromPathname = (pathname) => {
  let splittedUrl = pathname.slice(0, -1).split('/');
  if (splittedUrl.length > 2) {
    return splittedUrl[splittedUrl.length - 2];
  }

  return '';
};

const UserPaymentMethodView = ({ userId, paymentMethods, pageCount, page }) => {
  const paymentId = getPaymentIdFromPathname(window.location.pathname);
  const paymentMethod = paymentMethods.find(
    (method) => method.id === paymentId,
  );
  const isECheck = Boolean(paymentMethod?.echeck_type);
  return (
    <div>
      <h1>
        {paymentMethod?.id
          ? isECheck
            ? 'ECheck Payment Method'
            : 'Payment Method'
          : null}
      </h1>
      <p className="links">
        <Link className="mb-4" to={`/users/${userId}/payment-methods`}>
          &larr; Back to Payment Methods
        </Link>
      </p>
      <br />
      {paymentMethod?.id ? (
        isECheck ? (
          <UserECheckPaymentMethodDetails paymentDetails={paymentMethod} />
        ) : (
          <UserPaymentMethodDetails paymentDetails={paymentMethod} />
        )
      ) : null}
      <Pagination
        count={pageCount}
        current={page}
        url={(pageNum) => `/users/${userId}/payment-methods?page=${pageNum}`}
      />
    </div>
  );
};

export default compose(userPage, withPurchaseMethods)(UserPaymentMethodView);
